<template>
  <div class="saving-screen" v-if="isSaving">
    <span>Kaydediliyor, lütfen bekleyin....</span>
  </div>
  <div class="saving-screen" v-if="isLoading">
    <span>Yükleniyor, lütfen bekleyin....</span>
  </div>
  <r-flex class="r-edit-img-button-C">
    <r-btn @click="cancelF" size="medium" style="width: 100%">Vazgeç</r-btn>
    <r-btn
      style="width: 100%"
      @click="undoF"
      :disabled="aRects.length === 0 || isSaving"
      size="medium"
      bgcolor="#b17200"
    >
      Geri Al
    </r-btn>
    <r-btn
      style="width: 100%"
      @click="clearF"
      :disabled="aRects.length === 0 || isSaving"
      size="medium"
      bgcolor="#bb0202"
    >
      Tümünü Sil
    </r-btn>
    <r-btn
      style="width: 100%"
      @click="saveImages"
      :disabled="aRects.length === 0 || isSaving"
      size="medium"
      bgcolor="#009bc1"
      v-if="store.state.supers.indexOf(store.state.userrole) >= 0"
    >
      Seçimi Kırp
    </r-btn>
    <r-btn
      style="width: 100%"
      @click="drawOnSelection"
      :disabled="isSaving"
      size="medium"
      bgcolor="#607d8b"
    >
      Çiz
    </r-btn>
    <r-btn
      style="width: 100%"
      @click="saveOneImage"
      :disabled="aRects.length === 0 || isSaving"
      size="medium"
      bgcolor="#15880d"
    >
      Kaydet
    </r-btn>

    <div class="r-edit-img-draws-C">
      <div class="edit-draw-C"></div>
    </div>
  </r-flex>
  <div class="canvas-C">
    <canvas
      class="draw-canvas"
      id="imgcontent"
      width="1000"
      height="1412.857142857143"
    ></canvas>
    <canvas
      class="draw-canvas"
      id="drwcontent"
      width="1000"
      height="1412.857142857143"
    ></canvas>
    <canvas
      class="draw-canvas"
      id="tmpcontent"
      width="1000"
      height="1412.857142857143"
      style="cursor: auto"
      @mousedown="mDown"
      @mouseup="mUp"
      @mousemove="mMove"
      @mouseout="mOut"
      @touchstart="mDown"
      @touchend="mUp"
      @touchmove="mMove"
    ></canvas>
    <canvas
      class="draw-canvas"
      id="savecontent"
      width="1000"
      height="1412.857142857143"
    ></canvas>
    <div class="touch-rect-layer" :style="touchLayerStyle">
      <div
        v-for="rectIndex in touchRectIndexes"
        :key="'touch-rect-' + rectIndex"
        class="touch-rect-box"
        :class="{ active: activeTouchRectIndex === rectIndex }"
        :style="getTouchRectStyle(rectIndex)"
        @pointerdown.stop.prevent="startRectMove(rectIndex, $event)"
      >
        <div
          class="touch-rect-handle touch-rect-handle-x"
          @pointerdown.stop.prevent="startRectResize(rectIndex, 'x', $event)"
        ></div>
        <div
          class="touch-rect-handle touch-rect-handle-y"
          @pointerdown.stop.prevent="startRectResize(rectIndex, 'y', $event)"
        ></div>
        <div
          class="touch-rect-handle touch-rect-handle-xy"
          @pointerdown.stop.prevent="startRectResize(rectIndex, 'xy', $event)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  props: {
    img: String,
    data: Object,
    workFolder: {
      type: String,
      default: ""
    },
    close: Boolean,
    saveme: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const dataIn = ref(props.data);
    const cOffset = ref({});
    const aRects = ref([]);
    const saveImageDatas = ref([]);
    const showsave = ref(false);
    const readyImages = ref({});
    const imageIntervals = ref({});
    const canvases = ref({});
    const canvasesImages = ref({});
    const imgwidth = ref(null);
    const imgheight = ref(null);
    const isSaving = ref(false);
    const isLoading = ref(false);
    const imgContainer = ref();
    const rectCount = ref(0);
    const editMode = ref(false);
    const lastDrawOnSelectionAt = ref(0);
    
    const sameOriginImgSrc = computed(() => {
      const raw = String(props.img || "");
      if (process.env.NODE_ENV === "development" && raw.includes("localhost:44341/api/")) {
        return raw.replace(/https?:\/\/localhost:44341\/api\//, "/api/");
      }
      return raw;
    });

    var imgc, ictx, drwc, dctx, tmpc, tctx, savc, sctx;
    var startX, startY, mouseX, mouseY;
    var isDown = false;
    var issave = false;
    var maxselectbox = 3;
    var swidth, sheight;

    var txtout = false;
    var tbackpos;
    var ischrome = /chrome/.test(navigator.userAgent.toLowerCase());
    var rr = 1;
    var fnt1 = 15;
    var fnt2 = 17.8;
    var maxselecth = 10;
    var maxselectw = 20;
    var imgrect;
    var rect = null;
    const touchRectIndexes = ref([]);
    const activeTouchRectIndex = ref(null);
    const touchLayerStyle = ref({});
    const touchDragState = ref({
      isDragging: false,
      rectIndex: null,
      mode: "move",
      startClientX: 0,
      startClientY: 0,
      startRectX: 0,
      startRectY: 0,
      startRectW: 0,
      startRectH: 0
    });
    const minRectSize = 40;

    const normalizeTouchRectIndexes = () => {
      const max = aRects.value.length;
      touchRectIndexes.value = touchRectIndexes.value.filter(i => i < max);
      if (
        activeTouchRectIndex.value != null &&
        activeTouchRectIndex.value >= max
      ) {
        activeTouchRectIndex.value = null;
      }
    };

    const updateTouchLayerBounds = () => {
      if (!tmpc) return;
      touchLayerStyle.value = {
        left: (tmpc.offsetLeft || 0) + "px",
        top: (tmpc.offsetTop || 0) + "px",
        width: (tmpc.clientWidth || 0) + "px",
        height: (tmpc.clientHeight || 0) + "px"
      };
    };

    const canvasScale = () => {
      if (!imgc || !imgc.clientWidth) return 1;
      return swidth / imgc.clientWidth;
    };

    const clamp = (value, min, max) => {
      return Math.min(Math.max(value, min), max);
    };

    const syncRectDetail = rectIndex => {
      const target = aRects.value[rectIndex];
      if (!target || target.detailRowIndex == null) return;
      const row = dataIn.value.detail[target.detailRowIndex];
      if (!row) return;
      row.coordinates =
        Math.round(target.x) +
        ";" +
        Math.round(target.y) +
        ";" +
        Math.round(target.w) +
        ";" +
        Math.round(target.h) +
        ";";
    };

    const renderAllRectsToDrawCanvas = () => {
      if (!dctx) return;
      clear(dctx);
      aRects.value.forEach(rec => {
        if (rec && rec.w > 0 && rec.h > 0) {
          rec.finishRect(dctx, rr);
        }
      });
    };

    const drawOnSelection = () => {
      // Bazı cihazlarda tek dokunuş iki click üretip fonksiyonu çift tetikleyebiliyor.
      // Kısa süreli guard ile tek kutu eklenmesini garantiliyoruz.
      const now = Date.now();
      if (now - lastDrawOnSelectionAt.value < 350) return;
      lastDrawOnSelectionAt.value = now;

      if (isSaving.value) return;
      if (rectCount.value >= maxselectbox) {
        alert("En fazla üç seçim yapabilirsiniz.");
        return;
      }
      const scale = canvasScale();
      const defaultW = Math.round((imgc?.clientWidth || 1000) * 0.35 * scale);
      const defaultH = Math.round((imgc?.clientHeight || 1412) * 0.22 * scale);
      const x = Math.round((swidth - defaultW) / 2);
      const y = Math.round((sheight - defaultH) / 2);

      rect = new dRect();
      rect.x = clamp(x, 0, Math.max(0, swidth - minRectSize));
      rect.y = clamp(y, 0, Math.max(0, sheight - minRectSize));
      rect.w = clamp(defaultW, minRectSize, swidth - rect.x);
      rect.h = clamp(defaultH, minRectSize, sheight - rect.y);
      rect.ii = rectCount.value;
      rect.detailRowIndex = dataIn.value.detail.length;
      aRects.value.push(rect);
      touchRectIndexes.value.push(rect.ii);
      activeTouchRectIndex.value = rect.ii;
      rectCount.value++;

      dataIn.value.detail.push({
        coordinates:
          Math.round(rect.x) +
          ";" +
          Math.round(rect.y) +
          ";" +
          Math.round(rect.w) +
          ";" +
          Math.round(rect.h) +
          ";",
        note: "",
        referenceId: props.data.refid,
        fileName:
          dataIn.value.noteid +
          "_" +
          dataIn.value.pageNo +
          "_" +
          dateNow.value +
          "_" +
          (parseInt(dataIn.value.detail.length) + 1)
      });

      renderAllRectsToDrawCanvas();
    };

    const dateNow = computed(() => {
      let dt = new Date();
      return (
        dt
          .getDate()
          .toString()
          .padStart(2, "0") +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        dt.getFullYear() +
        "_" +
        dt
          .getHours()
          .toString()
          .padStart(2, "0") +
        dt
          .getMinutes()
          .toString()
          .padStart(2, "0") +
        dt
          .getSeconds()
          .toString()
          .padStart(2, "0")
      );
    });

    const startDraw = () => {
      isLoading.value = true;
      readyImages.value = {};
      imageIntervals.value = {};
      imgc = document.querySelector("#imgcontent");
      drwc = document.querySelector("#drwcontent");
      tmpc = document.querySelector("#tmpcontent");
      savc = document.querySelector("#savecontent");
      ictx = imgc.getContext("2d");
      dctx = drwc.getContext("2d");
      tctx = tmpc.getContext("2d");
      sctx = savc.getContext("2d");

      imgContainer.value = document.getElementsByClassName(
        "r-panel-content-C"
      )[0];

      swidth = imgc.width;
      sheight = imgc.height;
      imgrect = imgc.getBoundingClientRect();
      if (props.data.detail.length > 0) {
        editMode.value = true;
        props.data.detail.forEach(itm => {
          let arr = itm.coordinates.split(";");
          rect = new dRect();
          rect.x = arr[0];
          rect.y = arr[1];
          rect.w = arr[2];
          rect.h = arr[3];
          rect.txt =
            props.data.subcatname + " " + props.data.examnumber + ". soru";
          rect.txtdesc =
            props.data.notename +
            " " +
            //props.data.fassiculeId +
            " Sayfa " +
            props.data.pageNo.toString().padStart(3, "0");
          finishRect();
        });
      }
      editMode.value = false;

      cOffset.value.left = imgrect.left;
      cOffset.value.top = imgrect.top;
      updateTouchLayerBounds();
      addImage(ictx, rr);
      isLoading.value = false;
    };
    const undoF = () => {
      if (aRects.value.length > 0) {
        aRects.value.pop();
        if (
          dataIn.value.detail[dataIn.value.detail.length - 1].coordinates !==
          "0;0;0;0"
        ) {
          dataIn.value.detail.pop();
        } else {
          dataIn.value.detail.splice(dataIn.value.detail.length - 2, 1);
        }
        saveImageDatas.value.pop();
        clear(dctx);
        rectCount.value--;
        createAllRect(dctx, rr);
        normalizeTouchRectIndexes();
      }
    };
    const clearF = () => {
      aRects.value = [];
      saveImageDatas.value = [];
      dataIn.value.detail = [];
      touchRectIndexes.value = [];
      activeTouchRectIndex.value = null;

      clear(dctx);
      rectCount.value = 0;
    };
    const cancelF = () => {
      emit("update:close", false);
    };
    const addImage = (ctx, r) => {
      var img = new Image();
      img.crossOrigin = "anonymous"; // CORS header'lı görsel için gerekli - canvas tainted olmasın
      debugger;
      img.src = sameOriginImgSrc.value;
      debugger;

      img.onload = async function() {
        imgwidth.value = this.width;
        imgheight.value = this.height;
        ctx.drawImage(img, 0, 0, swidth * r, sheight * r);
      };
    };

    const getTouchRectStyle = rectIndex => {
      const target = aRects.value[rectIndex];
      if (!target) return {};
      const scale = canvasScale();
      return {
        left: target.x / scale + "px",
        top: target.y / scale + "px",
        width: target.w / scale + "px",
        height: target.h / scale + "px"
      };
    };

    const onTouchPointerMove = e => {
      if (!touchDragState.value.isDragging) return;
      const state = touchDragState.value;
      const target = aRects.value[state.rectIndex];
      if (!target) return;

      const scale = canvasScale();
      const dx = (e.clientX - state.startClientX) * scale;
      const dy = (e.clientY - state.startClientY) * scale;

      if (state.mode === "move") {
        target.x = clamp(
          state.startRectX + dx,
          0,
          Math.max(0, swidth - state.startRectW)
        );
        target.y = clamp(
          state.startRectY + dy,
          0,
          Math.max(0, sheight - state.startRectH)
        );
      } else if (state.mode === "x") {
        target.w = clamp(
          state.startRectW + dx,
          minRectSize,
          Math.max(minRectSize, swidth - state.startRectX)
        );
      } else if (state.mode === "y") {
        target.h = clamp(
          state.startRectH + dy,
          minRectSize,
          Math.max(minRectSize, sheight - state.startRectY)
        );
      } else if (state.mode === "xy") {
        target.w = clamp(
          state.startRectW + dx,
          minRectSize,
          Math.max(minRectSize, swidth - state.startRectX)
        );
        target.h = clamp(
          state.startRectH + dy,
          minRectSize,
          Math.max(minRectSize, sheight - state.startRectY)
        );
      }

      syncRectDetail(state.rectIndex);
      renderAllRectsToDrawCanvas();
    };

    const stopTouchDrag = () => {
      if (!touchDragState.value.isDragging) return;
      touchDragState.value.isDragging = false;
      window.removeEventListener("pointermove", onTouchPointerMove);
      window.removeEventListener("pointerup", stopTouchDrag);
      window.removeEventListener("pointercancel", stopTouchDrag);
    };

    const beginTouchDrag = (rectIndex, mode, e) => {
      const target = aRects.value[rectIndex];
      if (!target) return;
      activeTouchRectIndex.value = rectIndex;
      touchDragState.value = {
        isDragging: true,
        rectIndex,
        mode,
        startClientX: e.clientX,
        startClientY: e.clientY,
        startRectX: target.x,
        startRectY: target.y,
        startRectW: target.w,
        startRectH: target.h
      };
      window.addEventListener("pointermove", onTouchPointerMove);
      window.addEventListener("pointerup", stopTouchDrag);
      window.addEventListener("pointercancel", stopTouchDrag);
    };

    const startRectMove = (rectIndex, e) => {
      beginTouchDrag(rectIndex, "move", e);
    };

    const startRectResize = (rectIndex, mode, e) => {
      beginTouchDrag(rectIndex, mode, e);
    };

    const saveImages = () => {
      if (isSaving.value) return;
      isSaving.value = true;
      rr = imgwidth.value / 1000;
      addImages(sctx, rr);
    };
    const saveOneImage = () => {
      debugger;
      if (isSaving.value) return;
      isSaving.value = true;
      rr = imgwidth.value / 1000;
      (async () => {
        try {
          debugger;
          // Canvas'ı orijinal görsel boyutuna ayarla
          savc.width = imgwidth.value;
          savc.height = imgheight.value;
          sctx.clearRect(0, 0, imgwidth.value, imgheight.value);
          sctx.fillStyle = "#ffffff";
          // imgc canvas'ından (swidth x sheight) orijinal boyuta (imgwidth x imgheight) çiz
          sctx.drawImage(imgc, 0, 0, swidth, sheight, 0, 0, imgwidth.value, imgheight.value);
          createAllRect(sctx, rr);
          debugger;
          var b64img = savc
            .toDataURL("image/jpeg", 0.9)
            .replace("data:image/jpeg;base64,", "");

          if (b64img !== "") {
           
            saveImageDatas.value.push({
              ImageString: b64img,
              Location:
                "referansnotlari/" +
                props.workFolder +
                "/edited_ref_img_" +
                store.state.usertype +
                "/" +
                props.data.catid +
                "/" +
                dataIn.value.noteid +
                "/" +
                dataIn.value.noteid +
                "_" +
                dataIn.value.pageNo +
                "_" +
                dateNow.value +
                ".jpg",
              isImg: true
            });
            debugger;
            let res = await store.dispatch("postDatas", {
              api: "references/saveimages",
              data: saveImageDatas.value
            });
            debugger;
            dataIn.value.detail.forEach(det => {
              det.isImg = false;
            });
            dataIn.value.detail.forEach((det, i) => {
              if (det.coordinates === "0;0;0;0")
                dataIn.value.detail.splice(i, 1);
            });
            dataIn.value.detail.push({
              coordinates: "0;0;0;0",
              note: "",
              referenceId: props.data.refid,
              fileName:
                dataIn.value.noteid +
                "_" +
                dataIn.value.pageNo +
                "_" +
                dateNow.value,
              isImg: true
            });
            if (res.result) {
              dataIn.value.fileName =
                dataIn.value.noteid +
                "_" +
                dataIn.value.pageNo +
                "_" +
                dateNow.value;
              dataIn.value.originalUrl = "";
              dataIn.value.url = "";
              emit("update:close", false);
              emit("update:data", dataIn.value);
              emit("update:saveme", true);
              readyImages.value = {};
              canvasesImages.value = {};
              canvases.value = {};
              imageIntervals.value = {};
            }
          }
        } catch (error) {
          debugger;
          console.error("[saveOneImage] Canvas save error:", error);
          alert(
            "Canvas guvenlik kisiti nedeniyle kaydetme yapilamadi. Sayfayi yenileyip tekrar deneyin."
          );
        } finally {
          isSaving.value = false;
        }
      })();
    };

    debugger;
    const addImages = async (ctx, r) => {
      debugger;
      var img = new Image();
      img.crossOrigin = "anonymous";
      debugger;
      img.src = sameOriginImgSrc.value;
      debugger;
      img.onload = async function() {
        debugger;
        sctx.fillStyle = "#ffffff";
        savc.width = imgwidth.value * rr;
        savc.height = imgheight.value * rr;
        sctx.drawImage(img, 0, 0, swidth * r, sheight * r);
        var intii = 0;
        var saveok = true;
        var loopInt = setInterval(async () => {
          debugger;
          if (saveok) {
            saveok = false;
            sctx.clearRect(0, 0, imgwidth.value, imgheight.value);
            sctx.drawImage(img, 0, 0, swidth * r, sheight * r);
            sctx.fillStyle = "#ffffff";
            var itm = aRects.value[intii];
            await itm.createSaveRect(sctx, r);
            let topval = parseInt(itm.y) * r - parseInt(itm.titleh) - 20 * r;
            if (topval < 0) topval = 0;
            let botval = parseInt(itm.titleh) + parseInt(itm.h) * r + 40 * r;
            if (topval + botval > sheight * r)
              botval = sheight * r - topval - 2 * r;

            canvases.value["c" + itm.ii] = document.createElement("canvas");
            canvases.value["c" + itm.ii].width = swidth * r;
            canvases.value["c" + itm.ii].height = botval;
            canvases.value["c" + itm.ii].id = "canid" + itm.ii;

            var newimg = sctx.getImageData(0, topval, imgwidth.value, botval);

            canvasesImages["ci" + itm.ii] = canvases.value[
              "c" + itm.ii
            ].getContext("2d");
            canvasesImages["ci" + itm.ii].fillStyle = "#ffffff";
            canvasesImages["ci" + itm.ii].putImageData(newimg, 0, 0);

            readyImages.value["v" + itm.ii] = await canvases.value["c" + itm.ii]
              .toDataURL("image/jpeg", 0.9)
              .replace("data:image/jpeg;base64,", "");

            imageIntervals.value["i" + itm.ii] = setInterval(() => {
              debugger;
              if (readyImages.value["v" + itm.ii] !== "") {
                clearInterval(imageIntervals.value["i" + itm.ii]);
                delete imageIntervals.value["i" + itm.ii];

                saveImageDatas.value.push({
                  ImageString: readyImages.value["v" + itm.ii],
                  Location:
                    "referansnotlari/" +
                    props.workFolder +
                    "/edited_ref_img_" +
                    store.state.usertype +
                    "/" +
                    props.data.catid +
                    "/" +
                    dataIn.value.noteid +
                    "/" +
                    dataIn.value.noteid +
                    "_" +
                    dataIn.value.pageNo +
                    "_" +
                    dateNow.value +
                    "_" +
                    (parseInt(itm.ii) + 1) +
                    ".jpg"
                });
                if (itm.ii === aRects.value.length - 1) {
                  clearInterval(loopInt);
                } else {
                  saveok = true;
                }
                intii++;
              }
            }, 100);
          }
        }, 200);

        let intv = setInterval(async () => {
          debugger;
          if (saveImageDatas.value.length === aRects.value.length) {
            clearInterval(intv);

            let res = await store.dispatch("postDatas", {
              api: "references/saveimages",
              data: saveImageDatas.value
            });
            if (res.result) {
              for (let i = dataIn.value.detail.length - 1; i > 0; i--) {
                if (dataIn.value.detail[i].coordinates === "0;0;0;0")
                  dataIn.value.detail.splice(i, 1);
              }
              dataIn.value.detail.forEach((det, i) => {
                if (det.coordinates !== "0;0;0;0") {
                  det.fileName = saveImageDatas.value[i].Location.replace(
                    "referansnotlari/" +
                      props.workFolder +
                      "/edited_ref_img_" +
                      store.state.usertype +
                      "/" +
                      props.data.catid +
                      "/" +
                      dataIn.value.noteid +
                      "/",
                    ""
                  ).replace(".jpg", "");
                  det.isImg = true;
                }
              });
              dataIn.value.detail.forEach((det, i) => {
                if (det.coordinates === "0;0;0;0")
                  dataIn.value.detail.splice(i, 1);
              });
              dataIn.value.fileName =
                dataIn.value.noteid +
                "_" +
                dataIn.value.pageNo +
                "_" +
                dateNow.value;
              dataIn.value.originalUrl = "";
              dataIn.value.url = "";
              emit("update:close", false);
              emit("update:data", dataIn.value);
              emit("update:saveme", true);
              readyImages.value = {};
              canvasesImages.value = {};
              canvases.value = {};
              imageIntervals.value = {};
            }
          }
        }, 250);
      };
    };
    function dRect() {
      this.x = 0;
      this.y = 0;
      this.w = 1;
      this.h = 1;
      this.toth = 1;
      this.totw = 1;
      this.titleh = 1;
      this.titley = 1;
      this.ii = 0;
      this.rsp = 8;
      this.txt = props.data.subcatname + " " + props.data.examnumber + ". soru";
      this.txtdesc =
        props.data.notename +
        " " +
        //props.data.fassiculeId +
        "Sayfa " +
        props.data.pageNo.toString().padStart(3, "0");
    }
    dRect.prototype = {
      createRect: function(ctx, r) {
        ctx.lineWidth = 3;
        ctx.strokeStyle = "red";
        ctx.clearRect(0, 0, swidth, sheight);
        ctx.strokeRect(this.x * r, this.y * r, this.w * r, this.h * r);
        this.createText(ctx, r);
      },
      finishRect: function(ctx, r) {
        ctx.lineWidth = 4;
        ctx.strokeStyle = "#2b1869";
        ctx.strokeRect(this.x * r, this.y * r, this.w * r, this.h * r);
        this.createText(ctx, r);
      },
      createSaveRect: function(ctx, r) {
        ctx.lineWidth = 4 * r;
        ctx.strokeStyle = "#2b1869";
        ctx.strokeRect(this.x * r, this.y * r, this.w * r, this.h * r);
        this.createText(ctx, r, true);
      },
      createText: async function(ctx, r, s) {
        ctx.font = fnt1 * r + "pt Arial";
        var th = parseInt(ctx.font);
        var tw = ctx.measureText(this.txt).width;
        var backh;
        if (tw < 350 * r) {
          tw = 350 * r;
        }
        var mw = Math.abs(this.w * r);
        if (Math.abs(this.w) < 350 * r) {
          mw = 350 * r;
        }
        var lines = wrapText(ctx, this.txtdesc, mw);
        if (ischrome) {
          backh = lines.length * th;
        } else {
          if (!issave) {
            backh = lines.length * (th + 10);
          } else {
            backh = lines.length * (th + 6);
          }
        }
        ctx.font = fnt2 * r + "pt Arial";
        ctx.font = "bold";
        th = parseInt(ctx.font);
        backh = backh + th;
        this.titleh = backh;
        this.createTextBack(ctx, backh, tw, r, s);
        ctx.fillStyle = "#2C2257";
        var yy, xx;

        yy = this.titley + 30 * r;
        if (!txtout) {
          if (this.w * r < 0) {
            xx = this.x * r + this.w * r + 10;
          } else {
            xx = this.x * r + 10;
          }
        } else {
          xx = tbackpos + 10;
        }

        if (this.y * r - th - 10 > 0) {
          ctx.fillText(this.txt, xx, yy - 5);
        } else {
          ctx.fillText(this.txt, xx, yy - 5);
        }

        ctx.font = fnt1 * r + "pt Arial";
        ctx.fillStyle = "#2C2257";
        th = parseInt(ctx.font);

        lines.forEach(function(line, i) {
          let yp = yy + (th - 2 * r) * (i + 1);
          if (i > 0) yp = yy + (th - 2 * r) * (i + 1) + 4;
          if (ischrome) {
            ctx.fillText(line, xx, yp);
          } else {
            if (i === 0) ctx.fillText(line, xx, yp + 5);
            else ctx.fillText(line, xx, yp + 9);
          }
        });
      },
      createTextBack: function(ctx, th, tw, r, s) {
        ctx.beginPath();
        var ww, yy, xx;
        var oldh = 0;

        if (this.ii == 1 && !s) {
          oldh = aRects.value[0].y * r + aRects.value[0].h * r;
        }

        if (this.y * r - th - 15 > 0) {
          if (this.h * r < 0) {
            yy = this.y * r + this.h * r - th - 15;
          } else {
            yy = this.y * r - th - 15;
          }
          if (this.ii > 0) {
            if (parseInt(this.y * r - th - 15) < oldh) {
              yy = this.y * r + this.h * r;
            }
          }
        } else {
          if (this.y + this.h + th + 20 > sheight) {
            yy =
              this.y * r + this.h * r - (this.y + this.h + th + 20 - sheight);
          } else {
            yy = this.y * r + this.h * r;
          }
        }
        this.titley = yy;

        if (this.w * r < 0) {
          xx = this.x * r + this.w * r;
        } else {
          xx = this.x * r;
        }
        if (Math.abs(this.w * r) > tw + 20) {
          ww = Math.abs(this.w * r);
        } else {
          ww = tw + 20;
        }

        if (xx + ww > swidth * r) {
          txtout = true;
          xx = swidth * r - ww;
          tbackpos = xx;
        } else {
          txtout = false;
          }
        //todo: refras başlık arkaplan rengi.. burak
        ctx.rect(xx, yy, ww, th + 15 * r);
        ctx.fillStyle = "#FF7375";
        ctx.fill();
        ctx.strokeRect(xx, yy, ww, th + 15 * r);
        this.toth = th + 15;
        this.totw = ww;
      }
    };
    const wrapText = (ctx, txt, mw) => {
      var words = txt.split(" "),
        lines = [],
        line = "";
      if (ctx.measureText(txt).width < mw) {
        return [txt];
      }
      while (words.length > 0) {
        while (ctx.measureText(words[0]).width >= mw) {
          var tmp = words[0];
          words[0] = tmp.slice(0, -1);
          if (words.length > 1) {
            words[1] = tmp.slice(-1) + words[1];
          } else {
            words.push(tmp.slice(-1));
          }
        }
        if (ctx.measureText(line + words[0]).width + 15 < mw) {
          line += words.shift() + " ";
        } else {
          lines.push(line);
          line = "";
        }
        if (words.length === 0) {
          lines.push(line);
        }
      }
      return lines;
    };
    const mDown = e => {
      rect = new dRect();
      var p = swidth / imgc.clientWidth;
      startX = e.layerX * p;
      startY = e.layerY * p;
      if (rectCount.value < maxselectbox) {
        isDown = true;
      } else {
        console.log("En fazla üç seçim yapabilirsiniz", "alert");
      }
    };

    const mUp = () => {
      if (!isDown) {
        return;
      }
      isDown = false;
      finishRect();
      dataIn.value.detail.push({
        coordinates: rect.x + ";" + rect.y + ";" + rect.w + ";" + rect.h + ";",
        note: "",
        referenceId: props.data.refid,
        fileName:
          dataIn.value.noteid +
          "_" +
          dataIn.value.pageNo +
          "_" +
          dateNow.value +
          "_" +
          (parseInt(dataIn.value.detail.length) + 1)
      });
    };
    const mOut = () => {
      if (!isDown) {
        return;
      }
      isDown = false;
      finishRect();
      dataIn.value.detail.push({
        coordinates: rect.x + ";" + rect.y + ";" + rect.w + ";" + rect.h + ";",
        note: "",
        referenceId: props.data.refid,
        fileName:
          dataIn.value.noteid +
          "_" +
          dataIn.value.pageNo +
          "_" +
          dateNow.value +
          "_" +
          (parseInt(dataIn.value.detail.length) + 1)
      });
    };
    const mMove = e => {
      if (!isDown) {
        return;
      }
      var p = swidth / imgc.clientWidth;
      mouseX = parseInt(e.layerX * p);
      mouseY = parseInt(e.layerY * p);
      createRect();
    };
    const clear = c => {
      c.clearRect(0, 0, swidth, sheight);
    };
    const finishRect = () => {
      if (editMode.value) {
        if (
          rect.x !== "0" &&
          rect.y !== "0" &&
          rect.w !== "0" &&
          rect.h !== "0"
        ) {
          rect.ii = rectCount.value;
          aRects.value.push(rect);
          rect.finishRect(dctx, rr);
          rectCount.value++;
          clear(tctx);
        }
      } else {
        if (
          Math.abs(mouseX - startX) > maxselectw &&
          Math.abs(mouseY - startY) > maxselecth
        ) {
          if (rect.x !== 0 && rect.y !== 0 && rect.w !== 0 && rect.h !== 0) {
            rect.ii = rectCount.value;
            aRects.value.push(rect);
            rect.finishRect(dctx, rr);
            rectCount.value++;
            clear(tctx);
          }
        }
      }
    };
    const createRect = () => {
      if (
        Math.abs(mouseX - startX) > maxselectw &&
        Math.abs(mouseY - startY) > maxselecth
      ) {
        if (mouseY < startY) {
          if (mouseX > startX) {
            rect.x = startX;
            rect.w = mouseX - startX;
          } else {
            rect.x = mouseX;
            rect.w = startX - mouseX;
          }
          rect.y = mouseY;
          rect.h = startY - mouseY;
        } else {
          if (mouseX > startX) {
            rect.x = startX;
            rect.w = mouseX - startX;
          } else {
            rect.x = mouseX;
            rect.w = startX - mouseX;
          }
          rect.y = startY;
          rect.h = mouseY - startY;
        }
        if (rect.y + rect.h + rect.toth > sheight && rect.titley >= rect.y) {
          rect.h = sheight - rect.y - rect.toth;
        }
        rect.createRect(tctx, rr);
      }
    };
    const createAllRect = (ctx, r) => {
      aRects.value.forEach(rec => {
        if (rec.x !== 0 && rec.y !== 0 && rec.w !== 0 && rec.h !== 0)
          rec.createSaveRect(ctx, r);
      });
    };
    watch(
      () => props.img,
      () => {
        startDraw();
        aRects.value = [];
        rectCount.value = 0;
        touchRectIndexes.value = [];
        activeTouchRectIndex.value = null;
        clear(tctx);
        clear(dctx);
        updateTouchLayerBounds();
      }
    );
    onMounted(() => {
      startDraw();
      window.addEventListener("resize", updateTouchLayerBounds);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", updateTouchLayerBounds);
    });
    return {
      startDraw,
      undoF,
      clearF,
      cancelF,
      saveImages,
      saveOneImage,
      mDown,
      mUp,
      mMove,
      mOut,
      aRects,
      touchRectIndexes,
      activeTouchRectIndex,
      showsave,
      isSaving,
      isLoading,
      store,
      drawOnSelection,
      touchLayerStyle,
      getTouchRectStyle,
      startRectMove,
      startRectResize
    };
  }
};
</script>
<style>
.canvas-C {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.draw-canvas {
  position: absolute;
  height: 100%;
  widows: auto;
}
#imgcontent {
  z-index: 1;
}
#drwcontent {
  z-index: 2;
}
#tmpcontent {
  z-index: 3;
}
#savecontent {
  display: none;
}
.touch-rect-layer {
  position: absolute;
  inset: 0;
  z-index: 4;
  pointer-events: none;
}
.touch-rect-box {
  position: absolute;
  border: 2px dashed #2b1869;
  background: rgba(43, 24, 105, 0.08);
  box-sizing: border-box;
  pointer-events: auto;
  touch-action: none;
}
.touch-rect-box.active {
  border-color: #0061a8;
}
.touch-rect-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #0061a8;
  border-radius: 2px;
}
.touch-rect-handle-x {
  right: -7px;
  top: calc(50% - 7px);
  cursor: ew-resize;
}
.touch-rect-handle-y {
  bottom: -7px;
  left: calc(50% - 7px);
  cursor: ns-resize;
}
.touch-rect-handle-xy {
  right: -7px;
  bottom: -7px;
  cursor: nwse-resize;
}
.r-edit-img-button-C {
  position: absolute;
  top: calc(48% - 50px);
  z-index: 9;
  left: 100%;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  flex: 1 1 auto;
  width: 100px;
  background-color: #fff;
  padding: 4px;
  border-radius: 0 4px 4px 0;
}
</style>
